import { Box, Button, Container, TextField } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { displayError } from "../utils/misc";
import { useSelector } from "react-redux";
import RichText from "../components/RichText/component";
import "./index.css";
import { postTranslator } from "../utils/postTranslator";
import { useFAQsActions } from "../store/server/faq";

const langueges = {
  en: "English",
  uk: "Українська",
  ru: "Русский",
  es: "Español",
  cs: "Čeština",
  pl: "Polska",
  kk: "Қазақ",
  de: "Deutsch",
  th: 'แบบไทย',
  zh: '中國人',
  ja: '日本語'
};

const Page = () => {
  const { getOneClientFAQ, updateClientFAQ, createClientFAQ } = useFAQsActions();
  const { isPending } = useSelector((state) => state.faqs);
  const { tokens } = useSelector(state => state.auth)

  const params = useParams();
  const navigate = useNavigate();
  const [faq, setFaq] = useState({
    body: "",
    title: "",
    translations: [],
  });
  const [selectedFaq, setSelectedFaq] = useState(faq);

  const [selectedLang, setSelectedLang] = useState();

  const fetchFaq = async () => {
    const { payload, error } = await getOneClientFAQ(params.id);
    if (error) {
      return displayError(error.message);
    }
    setFaq(payload);
    setSelectedFaq(payload);
  };

  useEffect(() => {
    if (!!params?.id) {
      fetchFaq();
    }
    // eslint-disable-next-line
  }, [params?.id]);

  const onSubmit = async () => {
    if (!selectedFaq.title) return displayError("FAQ title is required");

    if (faq.id) {
      const {id, ...body} = faq
      const { error } = await updateClientFAQ({
        id,
        body: { ...body, translations: JSON.stringify(body.translations) },
      });
      if (error) {
        return displayError(error.message);
      }
      navigate("/client-faqs");
      return;
    }

    
    const { error } = await createClientFAQ({
      ...faq,
      translations: JSON.stringify(faq.translations)
    });
    if (error) {
      return displayError(error.message);
    }
    navigate("/client-faqs");
  };
  useEffect(() => {
    if(!tokens){
      navigate('/login')
    } 
// eslint-disable-next-line
  }, [tokens])

  return (
    <Box
      component="main"
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: "#e0f4ff",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            maxWidth: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            mt: "20px",
          }}
        >
          <Button
            color="warning"
            variant="contained"
            onClick={() => {
              navigate(`/client-faqs`);
            }}
          >
            <ArrowBackIcon />
            Back
          </Button>
          <div style={{ width: 10, height: 10 }} />
          <Button
            color="success"
            variant="contained"
            onClick={() => {
              onSubmit();
            }}
            disabled={isPending}
          >
            Publish
          </Button>
        </Box>
        <Box
          sx={{
            maxWidth: "100%",
            display: "flex",
            flexDirection: "row",
            flexWrap: 'wrap',
            justifyContent: "space-between",
            marginBlock: "10px",
          }}
        >
          <Button
            variant={!selectedLang ? "contained" : "secondary"}
            onClick={() => {
              setSelectedLang();
              setSelectedFaq(faq);
            }}
          >
            Origin
          </Button>
          {Object.keys(langueges).map((lang) => (
            <Button
            key={lang}
              variant={
                lang === selectedLang ? "contained" : "secondary"
              }
              onClick={() => {
                setSelectedLang(lang);
                setSelectedFaq( faq.translations.find(translate => translate.lang === lang) ?? {
                  title: '',
                  body: '',
                  lang
                });
              }}
            >
              {langueges[lang]?.slice(0, 3)}
            </Button>
          ))}
        </Box>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {!!selectedLang && (
            <Button
              color="info"
              variant="contained"
              sx={{ mb: "10px" }}
              onClick={async () => {
                const { translations, ...origin } = faq;
                const res = await postTranslator(origin, selectedLang);               
                const newTranslations = translations.filter(
                  (item) => item.lang !== selectedLang
                );
                newTranslations.push({...selectedFaq, ...res});
                setFaq({ ...faq, translations: newTranslations });
                setSelectedFaq({ ...selectedFaq, ...res });
              }}
            >
              {`Translate ${faq.body.length}/5000`}
            </Button>
          )}
          <h2
            style={{
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            {selectedFaq.title}
          </h2>
          <div
            className="post-wrapper"
            dangerouslySetInnerHTML={{
              __html: selectedFaq.body,
            }}
          />
        </div>
        <TextField
          fullWidth
          margin="dense"
          variant="standard"
          label="FAQ title"
          sx={{
            backgroundColor: "#FFF",
            borderRadius: "5px",
          }}
          value={selectedFaq.title || ""}
          onChange={(e) => {
            setSelectedFaq({
              ...selectedFaq,
              title: e.target.value,
            });
          }}
        />
        <Box sx={{ mt: "10px" }}>
          <RichText
            value={selectedFaq.body}
            setValue={(item) => {
              if (!!selectedLang) {
                const translations = faq.translations.filter(
                  (item) => item.lang !== selectedLang
                );
                translations.push({ ...selectedFaq, body: item });
                setFaq({ ...faq, translations: translations });
              } else {
                setFaq({ ...selectedFaq, body: item });
              }
              setSelectedFaq({ ...selectedFaq, body: item });
              window.scrollTo(0, 120);
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Page;
